import logger from 'OK/logger';
import { setCookie, clearCookie } from 'OK/cookie';
import honeypotAdblockDetect from 'OK/banners/blockDetect/honeypotBlockDetect';
import networkAdblockDetect from 'OK/banners/blockDetect/networkBlockDetect';
import { detect as _detect } from 'OK/wld';

function sendSuccess(data) {
    logger.success("nb_success", "detect", data);
}

function detect(cfg) {
    // в ie не детектим adblock
    if (document.documentElement.classList.contains('ie')) {
        return Promise.resolve(false);
    }

    return new Promise(function (resolve) {

        var network = networkAdblockDetect(cfg),
            honeypot = honeypotAdblockDetect(cfg),
            adpWhiteList = _detect(),
            done = 3,
            adpWhiteListSuccess,
            networkDetectSuccess,
            honeypotDetectSuccess;

        function isDetected() {
            return honeypotDetectSuccess || networkDetectSuccess;
        }

        function checkFinalOfDetection() {
            if (--done !== 0) {
                return;
            }

            var detected = isDetected() && !adpWhiteListSuccess;

            resolve(detected);

            if (detected) {
                if (honeypotDetectSuccess && networkDetectSuccess) {
                    sendSuccess("all");
                } else {
                    if (networkDetectSuccess) {
                        sendSuccess("network");
                    }
                    if (honeypotDetectSuccess) {
                        sendSuccess("honeypot");
                    }
                }
                setCookie('nbp', '1', 15, '/');
            } else {
                logger.success("nb_success", "not_detect", adpWhiteListSuccess ? "whitelist" : "");
                clearCookie('nbp', '/');
            }
        }

        function onSuccess(detected) {
            if (detected && (adpWhiteListSuccess === false)) {
                resolve(true);
            }
            return detected;
        }

        function onFail() {
            logger.success("nb_error", "detect", "catch");
            return false;
        }

        network.then(onSuccess, onFail).then(function (success) {
            networkDetectSuccess = success;
            checkFinalOfDetection();
        });

        honeypot.then(onSuccess, onFail).then(function (success) {
            honeypotDetectSuccess = success;
            checkFinalOfDetection();
        });

        adpWhiteList
            .then(
                function () {
                    // у нас adblock plus, включен белый список сайтов,
                    // заниматься обходом адблока нет смысла
                    resolve(false);
                    return true;
                },
                function () {
                    if (isDetected()) {
                        // не белый список и адблок уже был распознан
                        resolve(true);
                    }
                    return false;
                }
            )
            .then(function (detected) {
                adpWhiteListSuccess = detected;
                checkFinalOfDetection();
            });
    });
}

export default detect;
